import { useEffect, useState } from 'react';
import { BrowserRouter, NavLink, Route, Routes, useNavigate } from 'react-router-dom';
import { accessToken, handleCallback, logout, signedInUser } from './auth.ts';
import { CustomerDetail, Customers } from './pages/Customers.tsx';
import { Dashboard } from './pages/Dashboard.tsx';
import { Messages } from './pages/Messages.tsx';
import { OrderDetail } from './pages/OrderDetail.tsx';
import { Orders } from './pages/Orders.tsx';
import { Products } from './pages/Products.tsx';
import { Settings } from './pages/Settings.tsx';

function Callback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    handleCallback().then((back) => navigate(back, { replace: true }), (e: Error) => setError(e.message));
  }, [navigate]);
  return <div className="wrap">{error ? <div className="notice notice--error">{error} <a href="/">Try again</a></div> : <p className="muted">Signing in...</p>}</div>;
}

const NAV = [
  ['/', 'Dashboard'],
  ['/orders', 'Orders'],
  ['/products', 'Products'],
  ['/customers', 'Customers'],
  ['/messages', 'Messages'],
  ['/settings', 'Settings'],
] as const;

function Shell() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    // makes sure we hold a token before any page loads; redirects to sign in otherwise
    void accessToken().then(() => setReady(true));
  }, []);
  if (!ready) return <div className="wrap"><p className="muted">Checking sign-in...</p></div>;
  return (
    <>
      <header className="top">
        <div className="wrap top__bar">
          <a href="/" className="top__logo" aria-label="Dashboard">
            <img src="/wordmark-white.svg" alt="Native Smokes Superstore" width="150" height="42" />
          </a>
          <span className="top__tag">Admin</span>
          <span className="spacer" />
          <button className="linkbtn" type="button" onClick={logout} title={signedInUser() ?? ''}>Sign out</button>
        </div>
        <nav className="tabs" aria-label="Sections">
          <div className="wrap tabs__row">
            {NAV.map(([to, label]) => (
              <NavLink key={to} to={to} end={to === '/'}>{label}</NavLink>
            ))}
          </div>
        </nav>
      </header>
      <main className="wrap main">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:number" element={<OrderDetail />} />
          <Route path="/products" element={<Products />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/customers/:email" element={<CustomerDetail />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<p>Not found. <a href="/">Dashboard</a></p>} />
        </Routes>
      </main>
    </>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/callback" element={<Callback />} />
        <Route path="*" element={<Shell />} />
      </Routes>
    </BrowserRouter>
  );
}
